import { AppState } from '../../../../../../../store'

export const getTrustInfoData = (state: AppState) =>
  state.modules.trust.trustInfo
export const getActiveTrust = (state: AppState) =>
  state.modules.trust.trustInfo.activeTrust
export const getTrustFinanceDataState = (state: AppState) =>
  state.modules.trust.trustInfo.trustFinancialInfoState
